import { useEffect, useState } from "react";
import { useTeam } from "../../../context/TeamContext";
import { TeamWithDetails } from "../../../types/team.types";
import BoatForm from "./boat-form";
import { getObjectDiff } from "../../../utils/object-diff.utils";
import { BoatsAPI } from "../../../APIs/boats.api";
import { useToast } from "../../../components/toast";
import { useNavigate } from "react-router-dom";

export interface IBoatEditProps {
  onCancel: () => void;
  team: TeamWithDetails;
}

export function BoatEdit({ onCancel, team }: IBoatEditProps) {
  const { getTeam } = useTeam();
  const { addToast } = useToast();
  const [originalFormData, setOriginalFormData] =
    useState<TeamWithDetails | null>(null);
  const [modifiedFormData, setModifiedFormData] =
    useState<TeamWithDetails | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (team) {
      setOriginalFormData(team);
      setModifiedFormData(team);
    }
  }, [team]);

  const handleChange = (e: React.ChangeEvent<HTMLElement>) => {
    const { name, value, type, checked } = e.target as HTMLInputElement;

    setModifiedFormData((prev) => {
      if (!prev) return prev;

      return {
        ...prev,
        boat: {
          ...prev.boat!,
          [name]: type === "checkbox" ? checked : value,
        },
      };
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const changes = getObjectDiff(
        originalFormData?.boat,
        modifiedFormData?.boat
      );
      if (!changes) {
        addToast({
          message: "No se han realizado cambios",
          type: "info",
          location: "bottom-center",
        });
        navigate("/dashboard/my-boat");
        return;
      }
      const response = await BoatsAPI.patchBoat(changes);
      if (response.statusCode === 200) {
        getTeam();
        addToast({
          message: "¡Embarcación actualizada!",
          type: "success",
          location: "bottom-center",
        });
        navigate("#");
      } else {
        addToast({
          message: response.message,
          type: "error",
          location: "bottom-center",
          duration: 10000,
        });
      }
    } catch (error) {
      addToast({
        message: "Error al actualizar la embarcación, intente nuevamente",
        type: "error",
        location: "bottom-center",
        duration: 10000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  if (!modifiedFormData) {
    return null;
  }
  return (
    <BoatForm
      buttonText={"Guardar"}
      buttonVariant={"save"}
      boat={modifiedFormData.boat!}
      handleChange={handleChange}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      isSubmitting={isSubmitting}
    />
  );
}
